import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, BookOpen } from 'lucide-react';
const comparisonData = [{
  situation: 'Un vecino te pide cambiar un enchufe',
  without: 'No sabés cuánto cobrar',
  with: 'Presupuesto PDF en 5 minutos'
}, {
  situation: 'Querés cobrar por tus servicios',
  without: 'Sin argumento profesional',
  with: 'Catálogo de 10 servicios con precios'
}, {
  situation: 'Un cliente pide garantía escrita',
  without: 'No sabés qué poner',
  with: 'Plantilla de garantía lista'
}, {
  situation: 'Querés tus primeros clientes',
  without: 'No sabés por dónde empezar',
  with: 'Plan de 7 días sin publicidad'
}, {
  situation: 'Querés ganar los fines de semana',
  without: 'Sin sistema ni precio',
  with: '$200.000-$500.000/mes adicionales'
}];
const manualIncludes = ['Los 10 servicios más rentables del mercado', 'Fórmula exacta para calcular presupuestos', 'Plan para conseguir los primeros 5 clientes en 7 días', 'Plantillas de presupuesto, garantía y contrato', 'Protocolo de atención que genera referidos automáticos', 'Contratos de mantenimiento anual recurrente', 'Plan de 90 días con hitos semanales'];
export function ComparisonTable() {
  return <section className="py-14 bg-graphite border-y border-petroleum" data-id="element-47">
      <div className="container mx-auto px-4" data-id="element-48">
        <div className="text-center mb-8" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold flex items-center justify-center gap-3" data-id="element-50">
            <span className="text-2xl" data-id="element-51">🕊️</span> ¿QUÉ AGREGA EL MANUAL DEL
            ELECTRICISTA EMPRENDEDOR?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-10 overflow-x-auto" data-id="element-52">
          <table className="w-full text-left border-collapse" data-id="element-53">
            <thead data-id="element-54">
              <tr data-id="element-55">
                <th className="p-4 border-b border-white/10 text-textsecondary font-medium" data-id="element-56">
                  Situación real
                </th>
                <th className="p-4 border-b border-white/10 text-red-400 font-medium flex items-center gap-2" data-id="element-57">
                  <X className="w-4 h-4" data-id="element-58" /> Sin el Manual
                </th>
                <th className="p-4 border-b border-white/10 text-green-400 font-medium bg-petroleum/50 rounded-t-lg" data-id="element-59">
                  <div className="flex items-center gap-2" data-id="element-60">
                    <Check className="w-4 h-4" data-id="element-61" /> Con el Manual
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-62">
              {comparisonData.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-petroleum/30' : ''} data-id="element-63">
                  <td className="p-4 border-b border-white/5 text-white font-medium" data-id="element-64">
                    {row.situation}
                  </td>
                  <td className="p-4 border-b border-white/5 text-textsecondary" data-id="element-65">
                    {row.without}
                  </td>
                  <td className="p-4 border-b border-white/5 text-green-300 font-medium bg-petroleum/50" data-id="element-66">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="max-w-3xl mx-auto bg-petroleum border border-electric/20 rounded-2xl p-8" data-id="element-67">
          <h3 className="text-xl font-bold mb-6 flex items-center gap-2" data-id="element-68">
            <BookOpen className="w-5 h-5 text-gold" data-id="element-69" /> El Manual incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-70">
            {manualIncludes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-71">
                <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-72" />
                <span className="text-textsecondary text-sm" data-id="element-73">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}